<template>
  <div class="theme-light">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
